/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Text from '../Text/Text';
import './CenteredText.scss';

interface CenteredTextProps {
  text?: string;
  dropcap?: boolean;
}

/**
 * This is the CenteredText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function CenteredText({ text = '', dropcap = false }: CenteredTextProps) {
  return (
    <div className="block centered-text">
      <Text dropcap={dropcap}>{text}</Text>
    </div>
  );
}

export default CenteredText;
